var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c("div", [
    _c("section", { staticClass: "subpage-head" }, [
      _c(
        "div",
        { staticClass: "container" },
        [
          _c("h1", [_vm._v("Subscriptions")]),
          _vm._v(" "),
          _c(
            "router-link",
            { staticClass: "shtool", attrs: { to: { name: "user.profile2" } } },
            [_vm._v("Manage my profile")]
          )
        ],
        1
      )
    ]),
    _vm._v(" "),
    _c("section", { staticClass: "gen-list" }, [
      _c("div", { staticClass: "container" }, [
        _vm._m(0),
        _vm._v(" "),
        _c(
          "ul",
          { staticClass: "gen-list-content pkg-list" },
          [
            _vm._l(_vm.packages, function(pkg) {
              return !pkg.type2
                ? _c(
                    "li",
                    { class: { highlight: _vm.isHighlighted(pkg) } },
                    [
                      _c("h2", {
                        domProps: {
                          innerHTML: _vm._s(_vm.fancyTitle(pkg.title))
                        }
                      }),
                      _vm._v(" "),
                      _c("img", { attrs: { src: "files/" + pkg.photo } }),
                      _vm._v(" "),
                      _c("p", {
                        domProps: {
                          innerHTML: _vm._s(_vm.textToHtml(pkg.description))
                        }
                      }),
                      _vm._v(" "),
                      _c("div", { staticClass: "subsc-details" }, [
                        !_vm.activePayment(pkg)
                          ? _c("p", { staticClass: "not-subscribed" }, [
                              _vm._v(
                                "\n              Not subscribed\n            "
                              )
                            ])
                          : _c("p", { staticClass: "subscribed" }, [
                              _c("span", [_vm._v("Expires:")]),
                              _vm._v(" "),
                              _c("em", [
                                _vm._v(
                                  _vm._s(
                                    _vm.formatDate(
                                      _vm.activePayment(pkg).endDate,
                                      "MMM Do YYYY"
                                    )
                                  )
                                )
                              ])
                            ])
                      ]),
                      _vm._v(" "),
                      pkg.priceUsd
                        ? [
                            _c("div", { staticClass: "option" }, [
                              _c("p", [
                                _vm._v("30 days "),
                                _c("em", [
                                  _vm._v(_vm._s(_vm.formatPriceP(pkg.priceUsd)))
                                ])
                              ]),
                              _vm._v(" "),
                              _c(
                                "a",
                                {
                                  staticClass: "buy-btn",
                                  attrs: { href: "" },
                                  on: {
                                    click: function($event) {
                                      $event.preventDefault()
                                      return _vm.select(pkg, 0)
                                    }
                                  }
                                },
                                [
                                  _vm._v(
                                    _vm._s(
                                      !_vm.activePayment(pkg)
                                        ? "Subscribe"
                                        : "Extend"
                                    )
                                  )
                                ]
                              )
                            ]),
                            _vm._v(" "),
                            _c("div", { staticClass: "option" }, [
                              _c("p", [
                                _vm._v("3 months "),
                                _c("em", [
                                  _vm._v(
                                    _vm._s(_vm.formatPriceP(pkg.renewPriceUsd))
                                  )
                                ])
                              ]),
                              _vm._v(" "),
                              _c(
                                "a",
                                {
                                  staticClass: "buy-btn",
                                  attrs: { href: "" },
                                  on: {
                                    click: function($event) {
                                      $event.preventDefault()
                                      return _vm.select(pkg, 1)
                                    }
                                  }
                                },
                                [
                                  _vm._v(
                                    _vm._s(
                                      !_vm.activePayment(pkg)
                                        ? "Subscribe"
                                        : "Extend"
                                    )
                                  )
                                ]
                              )
                            ]),
                            _vm._v(" "),
                            _c("div", { staticClass: "option" }, [
                              _c("p", [
                                _vm._v("6 months "),
                                _c("em", [
                                  _vm._v(
                                    _vm._s(_vm.formatPriceP(pkg.renewPrice2Usd))
                                  )
                                ])
                              ]),
                              _vm._v(" "),
                              _c(
                                "a",
                                {
                                  staticClass: "buy-btn",
                                  attrs: { href: "" },
                                  on: {
                                    click: function($event) {
                                      $event.preventDefault()
                                      return _vm.select(pkg, 2)
                                    }
                                  }
                                },
                                [
                                  _vm._v(
                                    _vm._s(
                                      !_vm.activePayment(pkg)
                                        ? "Subscribe"
                                        : "Extend"
                                    )
                                  )
                                ]
                              )
                            ]),
                            _vm._v(" "),
                            _c("div", { staticClass: "option" }, [
                              _c("p", [
                                _vm._v("1 year "),
                                _c("em", [
                                  _vm._v(
                                    _vm._s(_vm.formatPriceP(pkg.renewPrice3Usd))
                                  )
                                ])
                              ]),
                              _vm._v(" "),
                              _c(
                                "a",
                                {
                                  staticClass: "buy-btn",
                                  attrs: { href: "" },
                                  on: {
                                    click: function($event) {
                                      $event.preventDefault()
                                      return _vm.select(pkg, 3)
                                    }
                                  }
                                },
                                [
                                  _vm._v(
                                    _vm._s(
                                      !_vm.activePayment(pkg)
                                        ? "Subscribe"
                                        : "Extend"
                                    )
                                  )
                                ]
                              )
                            ])
                          ]
                        : [
                            _c("div", { staticClass: "option option-one" }, [
                              _c("p", [
                                _vm._v(
                                  "these videos are available only to PPATT members"
                                )
                              ]),
                              _vm._v(" "),
                              _c(
                                "a",
                                {
                                  staticClass: "buy-btn buy-btn-one",
                                  attrs: { href: "" },
                                  on: {
                                    click: function($event) {
                                      $event.preventDefault()
                                    }
                                  }
                                },
                                [_vm._v("Request access")]
                              )
                            ])
                          ]
                    ],
                    2
                  )
                : _vm._e()
            }),
            _vm._v(" "),
            _vm._l(_vm.packages, function(pkg) {
              return pkg.type3
                ? _c(
                    "li",
                    {
                      staticClass: "aio",
                      class: { highlight: _vm.isHighlighted(pkg) }
                    },
                    [
                      _c("h2", {
                        domProps: {
                          innerHTML: _vm._s(_vm.fancyTitle(pkg.title))
                        }
                      }),
                      _vm._v(" "),
                      _c("div", { staticClass: "details" }, [
                        _c("img", { attrs: { src: "files/" + pkg.photo } })
                      ]),
                      _vm._v(" "),
                      _c(
                        "div",
                        { staticClass: "subsc-opts" },
                        [
                          _c("p", {
                            domProps: {
                              innerHTML: _vm._s(_vm.textToHtml(pkg.description))
                            }
                          }),
                          _vm._v(" "),
                          _c("div", { staticClass: "subsc-details" }, [
                            !_vm.activePayment(pkg)
                              ? _c("p", { staticClass: "not-subscribed" }, [
                                  _vm._v(
                                    "\n                Not subscribed\n              "
                                  )
                                ])
                              : _c("p", { staticClass: "subscribed" }, [
                                  _c("span", [_vm._v("Expires:")]),
                                  _vm._v(" "),
                                  _c("em", [
                                    _vm._v(
                                      _vm._s(
                                        _vm.formatDate(
                                          _vm.activePayment(pkg).endDate,
                                          "MMM Do YYYY"
                                        )
                                      )
                                    )
                                  ])
                                ])
                          ]),
                          _vm._v(" "),
                          pkg.priceUsd
                            ? [
                                _c("div", { staticClass: "option" }, [
                                  _c("p", [
                                    _vm._v(
                                      "\n                30 days\n                "
                                    ),
                                    _c("i", [
                                      _c("em", [
                                        _vm._v(
                                          _vm._s(_vm.formatPriceP(pkg.priceUsd))
                                        )
                                      ]),
                                      _vm._v(" "),
                                      pkg.priceEur * 1
                                        ? _c("span", [
                                            _vm._v("instead of "),
                                            _c("strong", [
                                              _vm._v(
                                                _vm._s(
                                                  _vm.formatPriceP(pkg.priceEur)
                                                )
                                              )
                                            ])
                                          ])
                                        : _vm._e()
                                    ])
                                  ]),
                                  _vm._v(" "),
                                  _c(
                                    "a",
                                    {
                                      staticClass: "buy-btn",
                                      attrs: { href: "" },
                                      on: {
                                        click: function($event) {
                                          $event.preventDefault()
                                          return _vm.select(pkg, 0)
                                        }
                                      }
                                    },
                                    [
                                      _vm._v(
                                        _vm._s(
                                          !_vm.activePayment(pkg)
                                            ? "Subscribe"
                                            : "Extend"
                                        )
                                      )
                                    ]
                                  )
                                ]),
                                _vm._v(" "),
                                _c("div", { staticClass: "option" }, [
                                  _c("p", [
                                    _vm._v(
                                      "\n                3 months\n                "
                                    ),
                                    _c("i", [
                                      _c("em", [
                                        _vm._v(
                                          _vm._s(
                                            _vm.formatPriceP(pkg.renewPriceUsd)
                                          )
                                        )
                                      ]),
                                      _vm._v(" "),
                                      pkg.renewPriceEur * 1
                                        ? _c("span", [
                                            _vm._v("instead of "),
                                            _c("strong", [
                                              _vm._v(
                                                _vm._s(
                                                  _vm.formatPriceP(
                                                    pkg.renewPriceEur
                                                  )
                                                )
                                              )
                                            ])
                                          ])
                                        : _vm._e()
                                    ])
                                  ]),
                                  _vm._v(" "),
                                  _c(
                                    "a",
                                    {
                                      staticClass: "buy-btn",
                                      attrs: { href: "" },
                                      on: {
                                        click: function($event) {
                                          $event.preventDefault()
                                          return _vm.select(pkg, 1)
                                        }
                                      }
                                    },
                                    [
                                      _vm._v(
                                        _vm._s(
                                          !_vm.activePayment(pkg)
                                            ? "Subscribe"
                                            : "Extend"
                                        )
                                      )
                                    ]
                                  )
                                ]),
                                _vm._v(" "),
                                _c("div", { staticClass: "option" }, [
                                  _c("p", [
                                    _vm._v(
                                      "\n                6 months\n                "
                                    ),
                                    _c("i", [
                                      _c("em", [
                                        _vm._v(
                                          _vm._s(
                                            _vm.formatPriceP(pkg.renewPrice2Usd)
                                          )
                                        )
                                      ]),
                                      _vm._v(" "),
                                      pkg.renewPrice2Eur * 1
                                        ? _c("span", [
                                            _vm._v("instead of "),
                                            _c("strong", [
                                              _vm._v(
                                                _vm._s(
                                                  _vm.formatPriceP(
                                                    pkg.renewPrice2Eur
                                                  )
                                                )
                                              )
                                            ])
                                          ])
                                        : _vm._e()
                                    ])
                                  ]),
                                  _vm._v(" "),
                                  _c(
                                    "a",
                                    {
                                      staticClass: "buy-btn",
                                      attrs: { href: "" },
                                      on: {
                                        click: function($event) {
                                          $event.preventDefault()
                                          return _vm.select(pkg, 2)
                                        }
                                      }
                                    },
                                    [
                                      _vm._v(
                                        _vm._s(
                                          !_vm.activePayment(pkg)
                                            ? "Subscribe"
                                            : "Extend"
                                        )
                                      )
                                    ]
                                  )
                                ]),
                                _vm._v(" "),
                                _c("div", { staticClass: "option" }, [
                                  _c("p", [
                                    _vm._v(
                                      "\n                1 year\n                "
                                    ),
                                    _c("i", [
                                      _c("em", [
                                        _vm._v(
                                          _vm._s(
                                            _vm.formatPriceP(pkg.renewPrice3Usd)
                                          )
                                        )
                                      ]),
                                      _vm._v(" "),
                                      pkg.renewPrice3Eur * 1
                                        ? _c("span", [
                                            _vm._v("instead of "),
                                            _c("strong", [
                                              _vm._v(
                                                _vm._s(
                                                  _vm.formatPriceP(
                                                    pkg.renewPrice3Eur
                                                  )
                                                )
                                              )
                                            ])
                                          ])
                                        : _vm._e()
                                    ])
                                  ]),
                                  _vm._v(" "),
                                  _c(
                                    "a",
                                    {
                                      staticClass: "buy-btn",
                                      attrs: { href: "" },
                                      on: {
                                        click: function($event) {
                                          $event.preventDefault()
                                          return _vm.select(pkg, 3)
                                        }
                                      }
                                    },
                                    [
                                      _vm._v(
                                        _vm._s(
                                          !_vm.activePayment(pkg)
                                            ? "Subscribe"
                                            : "Extend"
                                        )
                                      )
                                    ]
                                  )
                                ])
                              ]
                            : [
                                _c(
                                  "div",
                                  { staticClass: "option option-one" },
                                  [
                                    _c("p", [
                                      _vm._v(
                                        "these videos are available only to PPATT members"
                                      )
                                    ]),
                                    _vm._v(" "),
                                    _c(
                                      "a",
                                      {
                                        staticClass: "buy-btn buy-btn-one",
                                        attrs: { href: "" },
                                        on: {
                                          click: function($event) {
                                            $event.preventDefault()
                                          }
                                        }
                                      },
                                      [_vm._v("Request access")]
                                    )
                                  ]
                                )
                              ]
                        ],
                        2
                      )
                    ]
                  )
                : _vm._e()
            })
          ],
          2
        )
      ])
    ]),
    _vm._v(" "),
    _vm.videos.length
      ? _c("section", { staticClass: "gen-list" }, [
          _c("div", { staticClass: "container" }, [
            _vm._m(1),
            _vm._v(" "),
            _c(
              "ul",
              { staticClass: "gen-list-content pkg-list vidpkg-list" },
              _vm._l(_vm.videos, function(item) {
                return _c(
                  "li",
                  { class: { vid: item.media && item.media.store.id != 1 } },
                  [
                    _c("div", { staticClass: "preview" }, [
                      item.media &&
                      _vm.mediaUrl(item.media).indexOf("pdf") == -1
                        ? _c("img", {
                            attrs: { src: _vm.mediaUrl(item.media, item) }
                          })
                        : _vm._e(),
                      _vm._v(" "),
                      _c("span", { staticClass: "video" }),
                      _vm._v(" "),
                      _c("span", { staticClass: "cat" }, [
                        _vm._v(_vm._s(item.type && item.type.title))
                      ]),
                      _vm._v(" "),
                      _c("span", { staticClass: "stat" }, [_vm._v(_vm._s(""))])
                    ]),
                    _vm._v(" "),
                    _c(
                      "div",
                      { staticClass: "desc" },
                      [
                        _c("h5", [
                          _c("a", { attrs: { href: "" } }, [
                            (item.parent
                            ? item.parent.subtitle
                            : item.subtitle)
                              ? _c("em", [
                                  _vm._v(
                                    _vm._s(
                                      item.parent
                                        ? item.parent.subtitle
                                        : item.subtitle
                                    )
                                  )
                                ])
                              : _vm._e(),
                            _vm._v(" "),
                            _c("span", {
                              domProps: {
                                innerHTML: _vm._s(
                                  _vm.formatTitle(item.title) +
                                    _vm.formatMore(item.allVideos)
                                )
                              }
                            })
                          ])
                        ]),
                        _vm._v(" "),
                        _c("div", { staticClass: "subsc-details" }, [
                          _vm.activePaymentVid(item)
                            ? _c("p", { staticClass: "subscribed" }, [
                                _c("span", [_vm._v("Expires:")]),
                                _vm._v(" "),
                                _c("em", [
                                  _vm._v(
                                    _vm._s(
                                      _vm.formatDate(
                                        _vm.activePaymentVid(item).endDate,
                                        "MMM Do YYYY"
                                      )
                                    )
                                  )
                                ])
                              ])
                            : _vm._e()
                        ]),
                        _vm._v(" "),
                        _c("date", [
                          _vm._v(
                            _vm._s(_vm.formatDate(item.created, "MMM Do, YYYY"))
                          )
                        ])
                      ],
                      1
                    ),
                    _vm._v(" "),
                    item.priceUsd
                      ? [
                          item.priceUsd * 1
                            ? _c("div", { staticClass: "option" }, [
                                _c("p", [
                                  _vm._v("1 day "),
                                  _c("em", [
                                    _vm._v(
                                      _vm._s(_vm.formatPriceP(item.priceUsd))
                                    )
                                  ])
                                ]),
                                _vm._v(" "),
                                _c(
                                  "a",
                                  {
                                    staticClass: "buy-btn",
                                    attrs: { href: "" },
                                    on: {
                                      click: function($event) {
                                        $event.preventDefault()
                                        return _vm.selectVid(item, 0)
                                      }
                                    }
                                  },
                                  [_vm._v("Extend")]
                                )
                              ])
                            : _vm._e(),
                          _vm._v(" "),
                          item.price1 * 1
                            ? _c("div", { staticClass: "option" }, [
                                _c("p", [
                                  _vm._v("3 days "),
                                  _c("em", [
                                    _vm._v(
                                      _vm._s(_vm.formatPriceP(item.price1))
                                    )
                                  ])
                                ]),
                                _vm._v(" "),
                                _c(
                                  "a",
                                  {
                                    staticClass: "buy-btn",
                                    attrs: { href: "" },
                                    on: {
                                      click: function($event) {
                                        $event.preventDefault()
                                        return _vm.selectVid(item, 1)
                                      }
                                    }
                                  },
                                  [_vm._v("Extend")]
                                )
                              ])
                            : _vm._e(),
                          _vm._v(" "),
                          item.price2 * 1
                            ? _c("div", { staticClass: "option" }, [
                                _c("p", [
                                  _vm._v("7 days "),
                                  _c("em", [
                                    _vm._v(
                                      _vm._s(_vm.formatPriceP(item.price2))
                                    )
                                  ])
                                ]),
                                _vm._v(" "),
                                _c(
                                  "a",
                                  {
                                    staticClass: "buy-btn",
                                    attrs: { href: "" },
                                    on: {
                                      click: function($event) {
                                        $event.preventDefault()
                                        return _vm.selectVid(item, 2)
                                      }
                                    }
                                  },
                                  [_vm._v("Extend")]
                                )
                              ])
                            : _vm._e(),
                          _vm._v(" "),
                          item.price3 * 1
                            ? _c("div", { staticClass: "option" }, [
                                _c("p", [
                                  _vm._v("30 days "),
                                  _c("em", [
                                    _vm._v(
                                      _vm._s(_vm.formatPriceP(item.price3))
                                    )
                                  ])
                                ]),
                                _vm._v(" "),
                                _c(
                                  "a",
                                  {
                                    staticClass: "buy-btn",
                                    attrs: { href: "" },
                                    on: {
                                      click: function($event) {
                                        $event.preventDefault()
                                        return _vm.selectVid(item, 3)
                                      }
                                    }
                                  },
                                  [_vm._v("Extend")]
                                )
                              ])
                            : _vm._e(),
                          _vm._v(" "),
                          item.price4 * 1
                            ? _c("div", { staticClass: "option" }, [
                                _c("p", [
                                  _vm._v("90 days "),
                                  _c("em", [
                                    _vm._v(
                                      _vm._s(_vm.formatPriceP(item.price4))
                                    )
                                  ])
                                ]),
                                _vm._v(" "),
                                _c(
                                  "a",
                                  {
                                    staticClass: "buy-btn",
                                    attrs: { href: "" },
                                    on: {
                                      click: function($event) {
                                        $event.preventDefault()
                                        return _vm.selectVid(item, 4)
                                      }
                                    }
                                  },
                                  [_vm._v("Extend")]
                                )
                              ])
                            : _vm._e()
                        ]
                      : [
                          _c("div", { staticClass: "option option-one" }, [
                            _c("p", [
                              _vm._v(
                                "this video is available only to PPATT members"
                              )
                            ]),
                            _vm._v(" "),
                            _c(
                              "a",
                              {
                                staticClass: "buy-btn buy-btn-one",
                                attrs: { href: "" },
                                on: {
                                  click: function($event) {
                                    $event.preventDefault()
                                  }
                                }
                              },
                              [_vm._v("Request extension")]
                            )
                          ])
                        ],
                    _vm._v(" "),
                    _c("router-link", {
                      staticClass: "wlink",
                      attrs: {
                        to: { name: "content", params: { id: item.id } }
                      }
                    })
                  ],
                  2
                )
              }),
              0
            )
          ])
        ])
      : _vm._e()
  ])
}
var staticRenderFns = [
  function() {
    var _vm = this
    var _h = _vm.$createElement
    var _c = _vm._self._c || _h
    return _c("div", { staticClass: "gs-head" }, [
      _c("h2", [_vm._v("My Subscriptions")])
    ])
  },
  function() {
    var _vm = this
    var _h = _vm.$createElement
    var _c = _vm._self._c || _h
    return _c("div", { staticClass: "gs-head" }, [
      _c("h2", [_vm._v("My Videos and Tests")])
    ])
  }
]
render._withStripped = true

export { render, staticRenderFns }